export default __webpack_public_path__ + "static/media/PF_02.1b4d9baa.png";